const ONE_SECOND = 1000;

export function debounce(callback: Function, wait = ONE_SECOND) {
  let timeout: number;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(callback, wait);
  };
}
